import { useState } from "react"
import { bool, string, shape } from "prop-types"
import EventNameStep from "components/admin/events/new/EventNameStep"
import RegistrationTypeStep from "components/admin/events/new/RegistrationTypeStep"
import StepProgress from "components/admin/events/new/StepProgress"
import StepActions from "components/admin/events/new/StepActions"
import SignupPurposeStep from "components/admin/events/new/SignupPurposeStep"

const NewEvent = ({ event: initialEvent, organization }) => {
  const [step, setStep] = useState(0)
  const [event, setEvent] = useState(initialEvent)
  const [nextButtonDisabled, setNextButtonDisabled] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [signupPurpose, setSignupPurpose] = useState("specific")

  const steps = [
    { label: "Purpose", component: SignupPurposeStep },
    { label: "Type", component: RegistrationTypeStep },
    { label: "Name", component: EventNameStep }
  ]

  const CurrentStep = steps[step].component

  const handleSaveClick = () => {
    setIsLoading(true),
      fetch(`/signups/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": $.rails.csrfToken()
        },
        credentials: "include",
        body: JSON.stringify({ event: eventToParams() })
      })
        .then(resp => resp.json())
        .then(resp => {
          if (resp.errors) {
            alertModal({
              title: "An error occured",
              text: resp.errors,
              type: "error",
              confirmButtonText: "Ok",
              closeOnConfirm: true
            })
          } else {
            Turbolinks.visit(`/signups/${resp.id}/details`)
          }
        })
        .catch(resp => {
          alertModal({
            title: "An error occured",
            text: resp.errors,
            type: "error",
            confirmButtonText: "Ok",
            closeOnConfirm: true
          })
        })
  }

  const eventToParams = () => {
    let params = {
      name: event.name,
      currency: event.currency || "USD",
      registration_type: event.registrationType,
      attendee_types_attributes: {
        "0": {
          name: event.attendeeType.name,
          price: event.attendeeType.price || 0
        }
      }
    }

    const { startsAt } = event.eventTimes[0] || {}

    params = {
      ...params,
      ...(startsAt !== null && startsAt !== ""
        ? {
            event_times_attributes: event.eventTimes.map(eventTime => {
              return {
                starts_at: eventTime.startsAt,
                ends_at: eventTime.endsAt,
                all_day: eventTime.allDay
              }
            })
          }
        : {})
    }

    return params
  }

  return (
    <div className="max-width-780 mx-a mt-4 mt-8@md">
      <h1 className="font-size-3 c-neutral-500 tt-u mb-3 ta-c" css={{ letterSpacing: "0.04em" }}>
        Create a new signup
      </h1>
      <StepProgress steps={steps} currentStep={step} />
      <div className="pane">
        <div className="p-4">
          <CurrentStep
            organization={organization}
            event={event}
            setEvent={setEvent}
            setNextButtonDisabled={setNextButtonDisabled}
            signupPurpose={signupPurpose}
            onSignupPurposeChange={setSignupPurpose}
          />
        </div>
        <StepActions
          currentStep={step}
          totalSteps={steps.length}
          onSave={handleSaveClick}
          onStep={setStep}
          isLoading={isLoading}
          nextStepDisabled={nextButtonDisabled}
        />
      </div>
    </div>
  )
}

NewEvent.propTypes = {
  organization: shape({
    supportedCurrencies: string,
    currentCurrency: string
  }),
  event: shape({})
}

export default NewEvent
